import CandidateSubmissionModel, {
  SubmissionStatus,
} from "./CandidateSubmissionModel";
import LearnDashUserModel from "./LearnDashUserModel";
import StudentBaseModel from "./StudentBaseModel";

export default class CandidateModel extends StudentBaseModel {
  private __learnDashUser?: LearnDashUserModel;
  private __isQualified?: boolean;
  // TODO: remove everything related to the candidate submission
  candidate_submissions?: CandidateSubmissionModel[] | null;

  constructor(arg: any) {
    super(arg);
    this.__isQualified = arg.is_qualified;
    this.__learnDashUser = !!arg.learn_dash_user
      ? LearnDashUserModel.fromApiResponse(arg.learn_dash_user)
      : null;
    this.candidate_submissions = !!arg.candidate_submissions
      ? CandidateSubmissionModel.fromApiResponse(arg.candidate_submissions)
      : null;
  }
  get isUserQualified() {
    return !!this.__isQualified;
  }
  get learnDashUser() {
    return this.__learnDashUser || null;
  }

  get status() {
    let status: SubmissionStatus | undefined;
    if (this.candidate_submissions && this.candidate_submissions.length)
      status =
        this.candidate_submissions[this.candidate_submissions.length - 1]
          .status;
    return status || SubmissionStatus.waiting_audio;
  }
  get LastSubmissionUpdate() {
    if (this.candidate_submissions && this.candidate_submissions.length)
      return this.candidate_submissions[this.candidate_submissions.length - 1]
        .updated_at;
    else return this.updated_at;
  }
}
